function toggleSearchForm( sourceEvent ) {
	let button = sourceEvent.target;
	let theWrapper = button.closest('.search-form');
	let theForm = button.closest('form');
	let closeButton = theWrapper.querySelector( '.close-button' );
	let theField = theForm.querySelector('.search-field');
	let siteContainer = document.querySelector( '.site-container' );
	let siteFooter = document.querySelector( '.site-footer' );

	if( ! theWrapper.classList.contains('open') ) {
		sourceEvent.preventDefault();
		// theWrapper.classList.add('animating');
		theWrapper.classList.add('open');

		theWrapper.querySelector('.search-field').disabled = false;

		siteContainer.classList.add( 'almost-hidden' );
		siteFooter.classList.add( 'almost-hidden' );

		/*theField.addEventListener( 'transitionend', function formOpened( event ) {
			event.target.focus();
			event.target.removeEventListener( 'transitionend', formOpened );
		} );*/
	} else if( ! theField.val() ) {
		sourceEvent.preventDefault();
		// theWrapper.classList.add('animating');
		theWrapper.classList.remove('open');

		siteContainer.classList.remove( 'almost-hidden' );
		siteFooter.classList.remove( 'almost-hidden' );
	}

	/*theField.addEventListener( 'transitionend', function animationOver( event ) {
		theWrapper.classList.remove('animating');
		event.target.removeEventListener( 'transitionend', animationOver );
	} );*/
}

export default toggleSearchForm;